/*
 * Prestige Horizontal Scroll
 * -------------------------------------------------------------
 * Pins a section and translates a horizontal track sideways as
 * you scroll vertically. The section is made tall enough (in JS)
 * that the vertical scroll distance equals the track overflow, so
 * one full scroll-through pans the whole row.
 *
 * IntersectionObserver gate + single rAF loop. Reduced-motion
 * falls back to a normal horizontal-scroll strip (CSS).
 */
(function () {
  if (window.__prestigeHScrollInit) return;
  window.__prestigeHScrollInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = [];
  var ticking = false;

  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  function collect() {
    items = [];
    document.querySelectorAll('[data-hscroll]').forEach(function (sec) {
      var pin = sec.querySelector('.hl__pin');
      var track = sec.querySelector('.hl__track');
      if (pin && track) items.push({ sec: sec, pin: pin, track: track, distance: 0, visible: false });
    });
  }

  function size() {
    if (reduce) { items.forEach(function (it) { it.sec.style.height = ''; }); return; }
    var vw = window.innerWidth;
    items.forEach(function (it) {
      var distance = it.track.scrollWidth - vw;
      if (distance < 0) distance = 0;
      it.distance = distance;
      // The pinned band no longer needs to be the full viewport; use its
      // actual (sticky) height so the section is only as tall as the band.
      var ph = it.pin.offsetHeight;
      it.sec.style.height = (distance + ph) + 'px';
    });
  }

  function update() {
    ticking = false;
    if (reduce) return;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.visible) continue;
      var rect = it.sec.getBoundingClientRect();
      var max = it.sec.offsetHeight - it.pin.offsetHeight;
      // The band sticks below the header (CSS top offset), so measure progress
      // from that offset rather than the very top of the viewport.
      var topOff = parseFloat(getComputedStyle(it.pin).top) || 0;
      var p = clamp((topOff - rect.top) / (max || 1), 0, 1);
      it.track.style.transform = 'translate3d(' + (-p * it.distance).toFixed(1) + 'px,0,0)';
    }
  }

  function tick() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      for (var j = 0; j < items.length; j++) {
        if (items[j].sec === entries[i].target) items[j].visible = entries[i].isIntersecting;
      }
    }
    tick();
  }, { rootMargin: '0px' });

  function observe() { items.forEach(function (it) { io.observe(it.sec); }); }

  function init() {
    collect();
    size();
    observe();
    update();
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', function () { size(); tick(); }, { passive: true });
    window.addEventListener('load', function () { size(); tick(); }); // images can widen the track
    document.addEventListener('shopify:section:load', function () { collect(); size(); observe(); tick(); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
